import { useEffect, useState, useCallback } from 'react';
import { useMutation } from 'react-query';
import * as helpers from "../utils/utils.js"
import { useClientId } from "../context/context.js";
import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_URL;

export function useUnits() {
    const [unitData, setUnitData] = useState([]);
    const clientId = useClientId();

    const retrieveUnits = useCallback(async () => {
        const { data } = await axios.get(`${apiBaseUrl}/clients/${clientId}/units`);
        return data;
    }, [clientId]);

    // useEffect(() => {
    //     const fetchAndSetUnits = async () => {
    //         const units = await retrieveUnits();

    //         if (units) {
    //             const unitMap = {};
    //             for (let unit of units) {
    //                 unitMap[unit.id] = unit;
    //             }
    //             setUnitData(unitMap);
    //         }
            
    //     };

    //     fetchAndSetUnits();
    // }, [clientId, retrieveUnits]);  // This effect runs once when the component is mounted.


    const getUnit = (unitId) => {
        return unitData[unitId] || null;
    }

    const retrieveUnitById = async (id) => {
        const { data } = await axios.get(`${apiBaseUrl}/clients/${clientId}/units/${id}`);
        return { ...data, id};
    };
      
    return {
        unitData,
        getUnit,
        retrieveUnits,
        retrieveUnitById
    };
}
